import {TagAssignment, TagAssignmentEntity} from "../../../model/tag-assignment";
import {makeEntitySelectors} from "../base-entity-store";

export interface TagAssignmentSelectorProps {

}

const tagAssignmentSelectors = makeEntitySelectors<
  TagAssignment,
  TagAssignmentEntity,
  TagAssignmentSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => TagAssignmentEntity.from(value),
});

export const tagAssignmentsSelector =
  (props?: TagAssignmentSelectorProps) =>
    tagAssignmentSelectors.listSelector(props);

export const tagAssignmentSelector =
  () => tagAssignmentSelectors.singleSelector();
